import { render } from "./PotentialStudentList.vue?vue&type=template&id=6e482381&scoped=true"
import script from "./PotentialStudentList.vue?vue&type=script&lang=js"
export * from "./PotentialStudentList.vue?vue&type=script&lang=js"

import "./PotentialStudentList.vue?vue&type=style&index=0&id=6e482381&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e482381"]])

export default __exports__